(function() {
  'use strict';

  /* Shopify API Helpers */
  var apiGET, apiPOST, shopifyAPI;

  apiGET = function(url) {
    var eventName;
    eventName = ['copperhaus:', _.snakeCase(url).replace('_json', '').replace('_js', '')].join('');
    return new window.Promise(function(resolve, reject) {
      return $.getJSON(url).done(function(responseData) {
        $(document).trigger(eventName, [responseData]);
        return resolve(responseData);
      }).fail(function(jqXHR) {
        return reject(jqXHR.responseJSON);
      });
    });
  };

  apiPOST = function(url, data) {
    var eventName;
    eventName = ['copperhaus:', _.snakeCase(url).replace('_json', '').replace('_js', '')].join('');
    return new window.Promise(function(resolve, reject) {
      var params;
      params = {
        type: 'POST',
        url: url,
        data: data,
        dataType: 'json'
      };
      return $.ajax(params).done(function(responseData) {
        $(document).trigger(eventName, [responseData]);
        return resolve(responseData);
      }).fail(function(jqXHR) {
        var error;
        error = _.merge(jqXHR.responseJSON, data);
        return reject(error);
      });
    });
  };

  shopifyAPI = {
    getProduct: function(handle) {

      /* Returns JSON of the product */
      return apiGET("/products/" + handle + ".js");
    },
    getCart: function() {

      /* Returns JSON of the cart */
      return apiGET('/cart.json');
    },
    postForm: function(form) {

      /* Returns JSON of the line item */
      var data, url;
      url = '/cart/add.js';
      data = _.reduce($(form).serializeArray(), function(formObject, pair) {
        formObject[pair.name] = pair.value;
        return formObject;
      }, {});
      return apiPOST(url, data);
    },
    addItem: function(variantId, quantity) {

      /* Returns the JSON of the line item */

      /* associated with the added item */
      var data, url;
      url = '/cart/add.js';
      data = {
        id: variantId,
        quantity: quantity || 1
      };
      return apiPOST(url, data);
    },
    changeQty: function(variantId, quantity) {

      /* Returns JSON of the cart */
      var data, url;
      url = '/cart/change.js';
      data = {
        id: variantId,
        quantity: quantity || 1
      };
      return apiPOST(url, data);
    },
    removeItem: function(line) {

      /* Returns JSON of the cart */
      var data, url;
      url = '/cart/change.js';
      data = {
        line: line,
        quantity: 0
      };
      return apiPOST(url, data);
    },
    updateCartNote: function(note) {

      /* Returns JSON of the cart */
      var data, url;
      url = '/cart/update.js';
      data = {
        note: note
      };
      return apiPOST(url, data);
    }
  };

  window.copperhaus.fn.shopifyAPI = shopifyAPI;

}).call(this);
;

(function() {
  'use strict';

  /* Option Selection Callback */
  var selectCallback;

  selectCallback = function(variant, selector) {
    var formattedComparePrice, formattedPrice, matchProductId, message, moneyFormat, pricePlaceholder, productId, productTags, submitButton;
    $(document).trigger('copperhaus:variant_selected', [variant, selector]);
    message = variant ? "Sold Out" : "Unavailable";
    moneyFormat = _.get(window.copperhaus, 'shop.money_format', '$ {{amount}}');
    productId = _.get(selector, 'product.id', 0);
    matchProductId = function(index, element) {
      var match;
      match = $(element).attr('data-product-id') || 0;
      if (match) {
        return (match * 1) === productId;
      }
      return false;
    };
    submitButton = $(".js-add-to-cart").filter(matchProductId);
    pricePlaceholder = $('.js-price-preview').filter(matchProductId);
    
    // Envision - set the message to the content of the Sold Out Message tag
    productTags = _.get(selector, 'product.tags', 0);
    for (var i=0; i<productTags.length; i++) {
      if (productTags[i].toLowerCase().indexOf('sold out message:') != -1) {
        message = productTags[i].split(':')[1];
      }
    }
    
    if (variant && variant.available) {
      formattedPrice = window.Shopify.formatMoney(variant.price, moneyFormat);
      formattedComparePrice = window.Shopify.formatMoney(variant.compare_at_price, moneyFormat);
      submitButton.removeAttr('disabled').removeClass('disabled').prop('value', 'Add to cart');
      if (variant.price < variant.compare_at_price) {
        pricePlaceholder.html(formattedPrice + (" <del>" + formattedComparePrice + "</del>"));
      } else {
        pricePlaceholder.html(formattedPrice);
      }
    } else {
      submitButton.addClass('disabled').attr('disabled', 'disabled').prop('value', 'Out of stock');
      pricePlaceholder.html(message);
    }

    /* Trigger featured image update */
    $('.js-product-image-thumb').filter(matchProductId).trigger('copperhaus:variant_image_update', [variant.id]);
    return message;
  };

  window.customSelectCallback = selectCallback;

}).call(this);
;

(function() {
  'use strict';

  /* Multiple product option selectors */
  var cleanedUpIds, productIds, renderMultipleOptionSelectors;

  renderMultipleOptionSelectors = function(productId) {
    var product;
    if (!productId) {
      console.log("Product ID is not present");
      return;
    }
    product = _.get(window, "copperhausJSONProducts['" + productId + "']", null);
    if (!product) {
      console.log('Product JSON not found');
      return;
    }
    new window.Shopify.OptionSelectors("product-select-" + productId, {
      product: product,
      onVariantSelected: window.customSelectCallback
    });
  };

  productIds = $('.js-product-select').map(function(index, element) {
    return $(element).attr('data-product-id') || 0;
  }).get();


  /* Make sure no duplicate selectors appear */

  cleanedUpIds = _.chain(productIds).compact().uniq().value();

  _.forEach(cleanedUpIds, renderMultipleOptionSelectors);

}).call(this);
;

(function() {
  'use strict';

  /* Render AJAX Cart */
  var cartContainer, cartCount, renderCart, selectFieldText, titleContainer, mobileTitleContainer, quickOrderIndicator;

  cartContainer = $('.js-ajax-cart-container');

  titleContainer = $('.js-ajax-cart-title');
  mobileTitleContainer = $('.QuickOrderIndicator .js-ajax-cart-title');
  quickOrderIndicator = $('.QuickOrderIndicator');
  
  quickOrderIndicator.hide();
  quickOrderIndicator.on('click', function() {
    quickOrderIndicator.hide();
  });
  
  $(document).on('envision:added_cart_item', function(e) {
    quickOrderIndicator.show();
  });

  cartCount = $('.js-cart-item-count');

  selectFieldText = function(evt) {
    $(evt.target).select().one('mouseup', function(singleEvt) {
      return singleEvt.preventDefault();
    });
  };

  renderCart = function(evt, cart) {
    var items, summary, title, mobileTitle;
    items = _.map(cart.items, function(item, index) {
      var itemImage, itemName, renderedItem;
      itemName = item.product_title || '';
      itemImage = (item.image || '').replace(/(\.[^.]*)$/, "_small$1").replace('http:', '').replace('https:', '');
      renderedItem = $(document.createElement('article')).addClass('js-ajax-cart-item AjaxCartItem clearfix').attr('data-id', item.variant_id).append($(document.createElement('div')).addClass('AjaxCartItem-section is-image').append($(document.createElement('a')).addClass('AjaxCartItem-imageLink').attr('href', item.url).append($(document.createElement('div')).addClass('AjaxCartItem-imagePlaceholder').css('background-image', "url('" + itemImage + "')")))).append($(document.createElement('div')).addClass('AjaxCartItem-section is-info').append($(document.createElement('a')).addClass('AjaxCartItem-title').attr('href', item.url).text(itemName)).append($(document.createElement('div')).addClass('AjaxCartItem-variation').text(item.variant_title || ''))).append($(document.createElement('div')).addClass('AjaxCartItem-section is-price').append($(document.createElement('div')).addClass('js-ajax-cart-item-price AjaxCartItem-price').text(window.Shopify.formatMoney(item.line_price)))).append($(document.createElement('div')).addClass('AjaxCartItem-section is-qty').append($(document.createElement('label')).addClass('AjaxCartItem-qtyFieldLabel').text('Amount')).append($(document.createElement('input')).attr({
        'class': 'js-ajax-cart-qty AjaxCartItem-qtyField',
        'type': 'text',
        'value': item.quantity,
        'min': 0,
        'data-id': item.variant_id,
        'aria-label': 'quantity',
        'pattern': '[0-9]*'
      }))).append($(document.createElement('div')).addClass('AjaxCartItem-section is-remove').append($(document.createElement('a')).addClass('js-ajax-cart-remove AjaxCartItem-removeLink').attr({
        'href': "/cart/change?line=" + (index + 1) + "&amp;quantity=0",
        'data-line': index + 1
      }).text('Remove')));
      return renderedItem;
    });
    summary = $(document.createElement('section')).addClass('AjaxCartSummary').append($(document.createElement('div')).addClass('AjaxCartSummary-subtotalWrapper').append($(document.createElement('div')).addClass('AjaxCartSummary-subtotalLabel').text('Subtotal:')).append($(document.createElement('div')).addClass('js-ajax-cart-subtotal AjaxCartSummary-subtotal').text(window.Shopify.formatMoney(cart.total_price)))).append($(document.createElement('div')).addClass('AjaxCartSummary-buttonWrapper').append($(document.createElement('a')).addClass('AjaxCartSummary-checkoutButton button').attr('href', '/checkout').text('Checkout')));
    cartContainer.empty().append($(document.createElement('div')).addClass('js-cart-error AjaxCart-error')).append($(document.createElement('section')).addClass('AjaxCart-items').append(items)).append(summary);
    
    title = (function() {
      var itemWord;
      itemWord = cart.item_count === 1 ? 'item' : 'items';
      if (cart.item_count) {
        return "You have <strong>" + cart.item_count + "</strong> " + itemWord + " in your cart";
      }
      return 'Your cart is empty';
    })();
    mobileTitle = (function() {
      var itemWord;
      itemWord = cart.item_count === 1 ? 'item' : 'items';
      if (cart.item_count) {
        return "You have " + cart.item_count + " " + itemWord + " in your cart";
      }
      return 'Your cart is empty';
    })();
    titleContainer.empty().append($(document.createElement('a')).attr('href', '/cart').html(title));
    
    
    mobileTitleContainer.empty().append(`
	  <div class="title-container">
		<div class="title">${mobileTitle}</div>
		<div class="close-button">X</div>
	  </div>
	  <div class="button-container">
		<a class="button" href="/checkout">CHECK OUT</a>
		<a class="button secondary" href="javascript:void(0)">CONTINUE SHOPPING</a>
	  </div>
    `);
    
    /* Envision - Update cart item count in menu */
    $('.QuickOrderMenu .QuickOrderMenu-cart .cart-count').html(cart.item_count);
    
    /* Envision - Disable checkout button when subtotal is less than $50 */
    if (cart.total_price / 100 < 50) {
      // $('.AjaxCartSummary-checkoutButton.button').addClass('altcolor').removeAttr('href');
      var buttonParent = $('.AjaxCartSummary-checkoutButton.button').parent();
      $('.AjaxCartSummary-checkoutButton.button').remove();
      buttonParent.append('<p>You need at least $50 in your cart to check out.</p>');
    }
    
    /* Envision - hide mobile title if cart is empty */
    if (cart.item_count < 1) {
      $('.QuickOrderIndicator').addClass('hidden');
    } else {
      $('.QuickOrderIndicator').removeClass('hidden');
    }

    /* Update cart count in icon */
    cartCount.attr('data-item-count', cart.item_count);
  };


  /* Select all text in qty field on focus */

  cartContainer.on('focus', '.js-ajax-cart-qty', selectFieldText);


  /* Render cart on global event */

  $(document).on('copperhaus:cart', renderCart);

}).call(this);
;

(function() {
  'use strict';

  /* Init AJAX Cart */
  var Bacon, activityStatus, addActions, allCartActions, api, cartContainer, cartData, qtyActions, removeActions, submitButtons, wholesaleModeEnabled;

  Bacon = window.Bacon;

  api = window.copperhaus.fn.shopifyAPI;

  wholesaleModeEnabled = $('body').attr('data-shopify-template') === 'collection-wholesale';

  cartContainer = $('.js-ajax-cart-container');
  
  submitButtons = $('form[action^="/cart/add"] [type="submit"]');


  /* Set up event streams */

  addActions = submitButtons.asEventStream('click').flatMap(function(evt) {
    var form;
    evt.preventDefault();
    form = $(evt.delegateTarget).closest('form').first();
    return Bacon.fromPromise(api.postForm(form));
  });

  removeActions = cartContainer.asEventStream('click', '.js-ajax-cart-remove').flatMap(function(evt) {
    var itemLine, link;
    evt.preventDefault();
    link = $(evt.target);
    itemLine = link.attr('data-line');
    if (itemLine == null) {
      return 'Cart line number is not defined';
    }
    link.text('Removing…');
    return Bacon.fromPromise(api.removeItem(itemLine));
  });

  qtyActions = cartContainer.asEventStream('keyup', '.js-ajax-cart-qty').debounce(500).flatMap(function(evt) {
    var field, qty, variantId;
    evt.preventDefault();
    field = $(evt.target);
    variantId = field.attr('data-id') || '';
    qty = _.parseInt(field.val()) || 1;
    if (_.isFinite(qty) && variantId) {
      return Bacon.fromPromise(api.changeQty(variantId, qty));
    }
    return new Bacon.Error({
      description: 'Variant ID is not set'
    });
  });

  allCartActions = Bacon.mergeAll([addActions, removeActions, qtyActions]);


  /* Handle errors */

  allCartActions.onError(function(error) {
    var errorText, variantId;
    errorText = _.get(error, 'description', 'Unknown error');
    variantId = _.get(error, 'id', '');
    $('.js-cart-error').text(errorText);
    $('.js-product-form-error').filter("[data-variant-ids~='" + variantId + "']").text(errorText);
  });


  /* Update cart contents */

  cartData = Bacon.mergeAll([allCartActions, $(document).asEventStream('copperhaus:fetch_cart')]).flatMapLatest(function() {
    return Bacon.fromPromise(api.getCart());
  }).debounce(100);


  /* Indicate activity */

  activityStatus = Bacon.mergeAll([allCartActions.mapError('error'), allCartActions.map('doing'), $(document).asEventStream('copperhaus:variant_selected').map('done'), cartData.map('done')]).toProperty('done');

  activityStatus.onValue(function(status) {
    if (!_.isString(status)) {
      return;
    }
    $('.js-cart-activity-status').attr('data-status', status);
    if (status !== 'error') {
      $('.js-cart-error').empty();
      $('.js-product-form-error').empty();
    }
    if (status === 'doing') {
      submitButtons.prop('disabled', true);
      return;
    }
    
    /* Envision - prevent submit buttons for out-of-stock items from being enabled */
    submitButtons.filter(':not(.disabled)').prop('disabled', false);
  });


  /* Open cart drawer when product is added */

  addActions.onValue(function() {
    if (wholesaleModeEnabled) {
      return;
    }
    $(document).trigger('copperhaus:toggle_drawer', ['open']);
    $(document).trigger('envision:added_cart_item');
  });


  /* Init cart on page load */

  $(document).trigger('copperhaus:fetch_cart');

}).call(this);
